export default class ClickGuard {
  isAvailable() {
    return true
  }

  newLead() {
    const script = document.createElement('script')
    script.defer = true
    script.src = 'https://pulse.clickguard.com/sc'
    document.head.appendChild(script)
  }
}
